import { useEffect } from 'react';

// One in-page signal that the caller's admin inbox changed (read / dismiss / restore,
// or an alert preference that mutes a category). The header bell (notification-tray.tsx
// `useAdminInbox`) and the Notifications section both write the inbox and both show it,
// so each announces its writes and reloads on the other's. Named single-purpose file
// (CB-D3); no data travels on it — listeners refetch through api.ts.

const channel = new EventTarget();
const EVENT = 'admin-inbox-changed';

export function announceInboxChanged(): void {
  channel.dispatchEvent(new Event(EVENT));
}

export function useInboxChanged(onChange: () => void): void {
  useEffect(() => {
    const handler = () => onChange();
    channel.addEventListener(EVENT, handler);
    return () => channel.removeEventListener(EVENT, handler);
  }, [onChange]);
}
